import type { Theme } from '@mui/material';

export const styles = {
  tile: (theme: Theme) => ({
    backgroundColor: theme.colors.white,
    px: 2,
    pt: 2,
    pb: 4,
  }),

  imageWrapper: {
    margin: 'auto',

    'img, svg': {
      width: 'auto',
      height: '4rem',
    },
  },
};
